<div class="card">
  <div class="card-header d-md-block d-none">
    <app-page-title [breadcrumbItems]="breadCrumbItems"/>
  </div>
  <div class="p-3">
    <div class="d-flex justify-content-between align-items-center">
       <div>
         <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
           <i class="las la-tachometer-alt me-1"></i> {{ 'MENU.SMART_METERS' | translate }}
         </h4>
         <p class="p-0 m-0 fs-18 text-muted">{{ 'METER.MONITOR_MANAGE_SMART_METERS' | translate }}</p>
       </div>
      <button (click)="onAdd()" class="btn btn-primary d-inline-flex align-items-center gap-1 fs-18">
        <i class="las la-plus fs-20"></i><span class="fw-bolder">{{ 'METER.ADD_SMART_METER' | translate }}</span>
      </button>
    </div>
  </div>

  <ul class="nav custom-tabs cursor-pointer mb-3">
    <li class="nav-item">
      <a
        class="nav-link"
        [ngClass]="{ 'active': !activeTab }"
        (click)="setActiveTab()"
      >
        {{ 'METER.ALL_TYPES' | translate }}
      </a>
    </li>
    @for (unitType of unitTypes; track unitType) {
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{ 'active': activeTab === unitType.id }"
          (click)="setActiveTab(unitType.id)"
        >
          <figma-icon [name]="unitType.icon"></figma-icon>
          <span unitType [type]="unitType" [onlyText]="true"></span>

        </a>
      </li>
    }
  </ul>

  <div class="fs-12 d-flex align-center gap-2">
    <p class="p-0 m-0 text-muted fs-16">{{ 'METER.METERTYPE' | translate }}:</p>
    <ul class="list-style-none d-flex align-items-center gap-1">

      <li
        class="border px-2 cursor-pointer rounded-4 fw-bolder fs-16"
        [ngClass]="filter == 'all' ? 'bg-secondary text-light' : ''"
        (click)="setActiveFilter('all')"
      >
        {{ 'METER.ALL' | translate }}
      </li>

      <li
        class="border px-2 cursor-pointer rounded-4 fw-bolder fs-16"
        [ngClass]="filter == 'main' ? 'bg-secondary text-light' : ''"
        (click)="setActiveFilter('main')"
      >
        {{ 'METER.MAIN_METER' | translate }}
      </li>

      <li
        class="border px-2 cursor-pointer rounded-4 fw-bolder fs-16"
        [ngClass]="filter == 'unit' ? 'bg-secondary text-light' : ''"
        (click)="setActiveFilter('unit')"
      >
        {{ 'METER.UNIT_TYPE' | translate }}
      </li>
    </ul>
  </div>

  <div class="tab-content">
    @if (isLoading()) {
      <div class="mb-2">
        <p-skeleton class="custom-skeleton" [height]="'20rem'"></p-skeleton>
      </div>
    } @else {
      <div class="tab-content">
        @for (property of data(); track property) {
          <div class="mb-2">
            <div class="d-flex align-items-center gap-1 bg-light px-3 py-2 tab-header">
              <i class="ri-building-line fs-22"></i>
              <h3 class="p-0 m-0 mt-1 fs-24 fw-bolder">{{ property.name }}</h3>
              <span class="mt-1 fs-16 mx-2 border border-dark-subtle bg-light-subtle px-2 rounded-4">
              {{ getMetersCount(property) }} {{ 'METER.COUNTER' | translate }}
            </span>
            </div>
            <div>
              <div *ngIf="filter != 'unit'" class="px-2">
                <p class="mt-3 mb-1 text-muted fw-bolder fs-18" *ngIf="property?.ownMeters.length">{{ 'METER.MAIN_METER' | translate }}</p>
                <div class="row">
                  @for (meter of property.ownMeters; track meter) {
                    <div class="col-lg-4" (click)="showMeterDetails(meter)">
                      <meter-card
                        [data]="meter"
                        [property]="property.name"
                        [buildingType]="property.buildingType">
                      </meter-card>
                    </div>
                  }
                </div>
              </div>
              <div *ngIf="filter != 'main'" class="px-2">
                <p class="mt-3 mb-1 text-muted fw-bolder fs-18">{{ 'METER.UNIT_TYPE' | translate }}</p>
                <div class="row">
                  @for (apartment of property.apartments; track apartment) {
                    @for (meter of apartment.meters; track meter) {
                      <div class="col-lg-4" (click)="showMeterDetails(meter)">
                        <meter-card
                          [data]="meter"
                          [property]="property.name"
                          [apartment]="apartment.apartmentName">
                        </meter-card>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
